import React from 'react';
import svgTimesCircle from '../../svgs/times-circle.svg';
import Icon from '../Icon';

export default ({href, children})=>(
	<a href={href} className='TagButton'>
		"{children}" <Icon className='TagButton_icon' svg={svgTimesCircle}/>
	</a>
);